<template>
    <Header @language-selected="handleLanguageSelected"/>
        <section class="labels-page">
          <div class="container">
            <div class="integrations-heading privateNotes-heading">
              <h2>{{ $t('headersubmenu.Features.headerManageyouremail') }}</h2>
              <p>{{ $t('emailIntegration.emailIntegrationDashboard') }}</p>
              <div class="start-button">
                <a href="https://app.bcoor.com">{{
                  $t("automation.freeTrial")
                }}</a>
              </div>
          </div>
          <div class="labels-page-details">
            <p>{{ $t('emailIntegration.emailIntegrationomnichannelplatform') }}</p>
            <p class="mt-2">{{ $t('emailIntegration.emailIntegrationConnect') }}</p>
          </div>
          <div class="labels-page-contant">
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-6 col-12">
                <div class="labels-page-img">
                  <img src="../../../assets/images/emailIntegration/email-in-chatwoot.png">
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-12">
                <div class="labels-page-img-details">
                  <h4>{{ $t('emailIntegration.emailIntegrationeasily') }}</h4>
                  <p>{{ $t('emailIntegration.emailIntegrationcustomersManage') }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="labels-page-contant">
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-6 col-12 orderr-2">
                <div class="labels-page-img-details">
                  <h4>{{ $t('emailIntegration.emailIntegrationForwardtoemail') }}</h4>
                  <p>{{ $t('emailIntegration.emailIntegrationemailcustomer') }}</p>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-12 orderr-1">
                <div class="labels-page-img">
                  <img src="../../../assets/images/emailIntegration/forward-to-email-in-chatwoot.png">
                </div>
              </div>
            </div>
            </div>

              <div class="labels-page-contant">
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-6 col-12">
                <div class="labels-page-img">
                  <img src="../../../assets/images/emailIntegration/imap-email-settings-in-chatwoot.png">
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-12">
                <div class="labels-page-img-details">
                  <h4>{{ $t('emailIntegration.emailIntegrationSendemails') }}</h4>
                  <p>{{ $t('emailIntegration.emailIntegrationbcoorDashboard') }}</p>
                </div>
              </div>
            </div>
          </div>
         
          <div class="labels-page-contant">
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-6 col-12 orderr-2">
                <div class="labels-page-img-details">
                  <h4>{{ $t('emailIntegration.emailIntegrationoptions') }}</h4>
                  <p>{{ $t('emailIntegration.emailIntegrationNeedtocc') }}</p>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-12 orderr-1">
                <div class="labels-page-img">
                  <img src="../../../assets/images/emailIntegration/rich-emails-in-chatwoot.png">
                </div>
              </div>
            </div>
            </div>



          <div class="conversations d-none">
              <div class="row align-items-center">
                <div class="col-lg-6">
                  <div class="conversations-heading">
                    <h3>{{ $t('emailIntegration.emailIntegrationmanagingyour') }}</h3>
                    <p>{{ $t('emailIntegration.emailIntegratioconversations') }}</p>
                    <div class="signup-button">
                      <a href="https://app.bcoor.com">{{ $t('emailIntegration.sign_up_free') }}</a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="conversations-img">
                    <img src="../../../assets/images/automations/dashboard-small.webp">
                  </div>
                </div>
              </div>
          </div>
          </div>

        </section>
    <Footer :selectLanguage="selectLanguage"/>
</template>

<script>
    import Footer from "@/views/chatwoot/Footer.vue";
        import Header from "@/views/chatwoot/Header.vue";
    
        export default {
      name: "sharedInbox",
      components: {
        Footer,
        Header
      },
          data () {
            return {
              selectLanguage: 'en',
            };
          },
          methods: {
            handleLanguageSelected (language) {
              this.selectLanguage = language;
            },
          },
          created() {
            const localStorageItem = localStorage.getItem('language');

            if (localStorageItem) {

              this.selectLanguage = localStorageItem;
            }
          }
    }
    </script>